import styled from '@emotion/styled';
import Drawer from '@base/Drawer/Drawer';
import H2 from '@base/H2/H2';
import { Spacings, Fonts } from '@styles/index';
import { FC } from 'react';
import H4 from '@base/H4/H4';
import P1 from '@base/P1/P1';
import { AnyArgVoidReturnFunction } from 'types/utils';

const DrawerHeader = styled(H2)`
  grid-column: span 10;
`;

const FAQHeader = styled(DrawerHeader)`
  margin-bottom: ${Spacings.SPACING_5B};
`;

const FAQFooter = styled.span`
  font-size: ${Fonts.H5};
  color: var(--color-text-primary);
  margin-top: ${Spacings.SPACING_25B};
  margin-bottom: ${Spacings.SPACING_12B};
  grid-column: span 10;
`;

const FAQAction = styled.span`
  font-size: ${Fonts.H5};
  color: var(--color-i-green);
  font-weight: ${Fonts.SEMIBOLD};
  margin-left: ${Spacings.SPACING_2B};
  border-bottom: dashed 1px var(--color-i-green);
  cursor: pointer;
`;

const FAQWrapper = styled.div`
  grid-column: span 10;
`;

const FAQContentBlock = styled.div`
  margin: ${Spacings.SPACING_5B} 0;
`;

const FAQQuestion = styled(H4)`
  margin-bottom: ${Spacings.SPACING_2B};
`;

const FAQAnswer = styled(P1)`
  font-size: ${Fonts.LARGE};
`;

type FAQSDrawerProps = {
  showFAQDrawer: boolean;
  setShowFAQDrawer: AnyArgVoidReturnFunction;
  faqs: Array<{
    id: number;
    question: string;
    answer: string;
  }>;
};

const FAQSDrawer: FC<FAQSDrawerProps> = ({
  showFAQDrawer,
  setShowFAQDrawer,
  faqs
}) => {
  return (
    <Drawer drawerState={showFAQDrawer} onClose={() => setShowFAQDrawer(false)}>
      <FAQHeader>Upgrade FAQs</FAQHeader>
      <FAQWrapper>
        {faqs.map((faq) => {
          return (
            <FAQContentBlock key={faq.id}>
              <FAQQuestion>{faq.question}</FAQQuestion>
              <FAQAnswer>{faq.answer}</FAQAnswer>
            </FAQContentBlock>
          );
        })}
      </FAQWrapper>
      <FAQFooter>
        Need help with Iconic subscription?
        <a href="mailTo:help@unacademy.com">
          <FAQAction>Contact us</FAQAction>
        </a>
      </FAQFooter>
    </Drawer>
  );
};

export default FAQSDrawer;
